"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app");
const responseError = require("./common/responseError");
const identifiers_1 = require("./identifiers");
const getCourseEnrollments_1 = require("./getCourseEnrollments");
const updateCourse_1 = require("./updateCourse");
const getCourses_1 = require("./getCourses");
function addCourseEnrollmentDoc({ userId, courseId, role }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const courseEnrollmentsDoc = yield getCourseEnrollments_1.default({
                userId,
                courseId,
                role
            });
            if (!courseEnrollmentsDoc.length) {
                const docRef = yield app_1.app.firestore.collection(`courseEnrollments`).add({
                    userId,
                    courseId,
                    role
                });
                const courseDoc = yield getCourses_1.default({ courseId });
                if (role === identifiers_1.Types.UserPermissionRoles.STUDENT) {
                    yield updateCourse_1.default(courseId, { noOfStudents: ++courseDoc[0].noOfStudents });
                }
                console.log('Document written with ID: ', docRef.id);
                return { id: docRef.id };
            }
            else {
                console.log('Document with given information already exists in courseEnrollments collection');
                return { id: courseEnrollmentsDoc[0].id };
            }
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = addCourseEnrollmentDoc;
//# sourceMappingURL=addCourseEnrollment.js.map